import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px'
  },

  tabs: {
    position: 'relative',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    marginTop: '-23px',
    marginBottom: '10px',
    maxWidth: 'fit-content',

    [theme.breakpoints.down('md')]: {
      marginTop: '0.5rem'
    }
  },

  tab: {
    fontSize: theme.size.sm
  },

  body: {
    width: '100%',
    overflow: 'hidden',

    '&:hover': {
      overflowY: 'overlay'
    },

    '&:not(:last-child)': {
      marginRight: '15px'
    },

    '& .editor-input': {
      minHeight: 'unset'
    },

    '& .text': {
      width: '100%',
      height: 'auto',
      backgroundColor: 'transparent',
      color: '#323436',
      resize: 'none',

      '& div > div > textarea.text__input': {
        padding: '0 !important'
      },

      '& div > div > .text__highlighter': {
        height: 'auto !important'
      },

      '& div > .text__control ': {
        height: 'auto !important'
      }
    }
  },

  editor: {
    '& .editor': {
      border: '1px solid #E0E0E0',
      borderRadius: '4px'
    },

    '& .editor-input': {
      minHeight: '50px !important'
    }
  },

  count: {
    position: 'absolute',
    top: '0',
    left: '2rem',
    height: 'auto',
    color: 'rgba(50, 52, 54, 0.35)',
    userSelect: 'none'
  }
}))

export default useStyles
